// src/locales/es.js
// VEGA ROBOTICS - Traducciones en Español

export default {
  // ============================================================
  // GENERAL
  // ============================================================
  general: {
    company: 'Vega Robotics',
    tagline: 'Inteligencia Artificial para la Industria',
    learnMore: 'Saber más',
    contactUs: 'Contáctenos',
    getStarted: 'Comenzar',
    readMore: 'Leer Más',
    viewAll: 'Ver Todos',
    loading: 'Cargando...',
    error: 'Ocurrió un error',
    success: '¡Éxito!',
    send: 'Enviar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    search: 'Buscar',
    filter: 'Filtrar',
    sortBy: 'Ordenar por',
    all: 'Todos',
    none: 'Ninguno',
    yes: 'Sí',
    no: 'No',
    scheduleDemo: 'Agendar una Demo',
    scheduleMeeting: 'Agendar Reunión',
    requestQuote: 'Solicitar Presupuesto',
  },

  // ============================================================
  // HEADER / NAVEGACIÓN
  // ============================================================
  nav: {
    home: 'Inicio',
    about: 'Nosotros',
    solutions: 'Soluciones',
    testimonials: 'Testimonios',
    blog: 'Blog',
    contact: 'Contacto',
    investors: 'Inversores',
    careers: 'Carreras',
    products: 'Productos',
    services: 'Servicios',
    partners: 'Socios',
  },

  // ============================================================
  // HERO SECTION
  // ============================================================
  hero: {
    eyebrow: 'Tecnología brasileña para la industria global',
    titleStatic: 'Soluciones para quien',
    title: 'Visión por Computadora para Industria 4.0',
    subtitle: 'Transforme su línea de producción con inteligencia artificial. Detecte defectos en tiempo real y aumente la calidad.',
    button: 'Conozca nuestras Soluciones',
    cta: 'Agendar una Demo',
    ctaSecondary: 'Conozca Nuestras Soluciones',
    trusted: 'Confiado por empresas líderes',
    verbs: [
      'transforma',
      'automatiza',
      'produce',
      'monta',
      'estampa',
      'organiza',
      'controla',
      'entrega',
    ],
  },

  // ============================================================
  // SOLUCIONES
  // ============================================================
  solutions: {
    title: 'Nuestras soluciones',
    subtitle: 'Tecnología de punta para transformar su operación industrial',
    
    engenhariaAplicada: {
      name: 'Ingeniería Aplicada',
      description: 'Proyectos a demanda para su operación industrial',
    },
    automacaoIndustrial: {
      name: 'Automatización Industrial',
      description: 'Celdas y sistemas que aumentan productividad y precisión',
    },
    qualidadeInteligente: {
      name: 'Calidad Inteligente',
      description: 'Inspección visual con IA para cero defectos',
    },
    agentesIndustriais: {
      name: 'Agentes Industriales',
      description: 'IA generativa aplicada a sus procesos',
    },
    
    vixem: {
      name: 'VIXEM',
      tagline: 'Visión por Computadora Edge',
      description: 'Sistema de inspección visual con IA embebida para detección de defectos en tiempo real en la línea de producción.',
      features: [
        'Detección de defectos en milisegundos',
        'Funciona sin conexión (edge computing)',
        'Integración con sistemas MES/ERP',
        'Dashboard de calidad en tiempo real',
      ],
    },
    
    cadpro: {
      name: 'CADPro',
      tagline: 'Servicios de Ingeniería',
      description: 'Proyectos de herramentales, dispositivos y automatización industrial con ingeniería de alta precisión.',
      features: [
        'Diseño de troqueles y matrices',
        'Dispositivos de control',
        'Automatización de procesos',
        'Consultoría técnica especializada',
      ],
    },
    
    proagentes: {
      name: 'PROAgentes.ai',
      tagline: 'Agentes de IA',
      description: 'Plataforma de agentes inteligentes para automatización de procesos empresariales y atención.',
      features: [
        'Agentes conversacionales',
        'Automatización de tareas',
        'Integración con sistemas',
        'Análisis de datos inteligente',
      ],
    },
  },

  // ============================================================
  // TESTIMONIOS
  // ============================================================
  testimonials: {
    title: 'Lo que dicen de nosotros',
    subtitle: 'Vea cómo estamos transformando la industria brasileña',
    prev: 'Anterior',
    next: 'Siguiente',
    goToSlide: 'Ir al slide',
    
    items: [
      {
        text: '¡Profesionales de la más alta calidad! Servicio incomparable.',
        author: 'Rodrigo',
      },
      {
        text: 'Empresa de vanguardia en automatización y robótica. Trabajo de alta calidad, y el equipo demuestra gran competencia técnica. Lo recomiendo a quienes buscan innovación y socios confiables en el sector tecnológico.',
        author: 'Anderson Fernandes',
      },
      {
        text: 'Excelente empresa. Tiene gran servicio y confiabilidad.',
        author: 'Danilo Carvalho Souza',
      },
      {
        text: 'Recomiendo fuertemente esta empresa para quienes buscan innovación, calidad en visión por computadora e IA. Vega Robotics entrega soluciones de vanguardia para la industria con compromiso con la excelencia.',
        author: 'Sttela Bastos',
      },
    ],
  },

  // ============================================================
  // CTA
  // ============================================================
  cta: {
    title: '¿Listo para transformar su industria?',
    subtitle: 'Hable con nuestros especialistas. Respondemos en hasta 24h.',
  },

  // ============================================================
  // BLOG
  // ============================================================
  blog: {
    title: 'Contenido que transforma',
    subtitle: 'Artículos, casos y novedades sobre IA, automatización e industria 4.0',
    readTime: 'min de lectura',
    viewAll: 'Ver todos los artículos',
    noPosts: 'No se encontraron artículos.',
    loadMore: 'Cargar Más',

    // Página del Blog
    pageTitle: 'Blog Vega Robotics',
    pageSubtitle: 'Artículos sobre tecnología, innovación, inteligencia artificial y el futuro de la industria brasileña.',
    allCategories: 'Todos',
    noPostsTitle: 'No se encontraron posts',
    noPostsText: '¡Pronto tendremos novedades!',
    noPostsCategory: 'Aún no hay posts en esta categoría.',
    readMore: 'Leer más',
    views: 'vistas',
    backToBlog: 'Volver al Blog',
    share: 'Compartir',

    categories: {
      all: 'Todos',
      computerVision: 'Visión por Computadora',
      edgeComputing: 'Edge Computing',
      ai: 'Inteligencia Artificial',
      industry: 'Industria 4.0',
      vision: 'Visión por Computadora',
      automation: 'Automatización',
      news: 'Noticias',
      tecnologia: 'Tecnología',
      industria: 'Industria 4.0',
      ia: 'Inteligencia Artificial',
      inovacao: 'Innovación',
      cases: 'Casos de Éxito',
      tutoriais: 'Tutoriales',
    },

    posts: [
      {
        title: 'Cómo la Visión por Computadora está transformando la calidad industrial',
        excerpt: 'Descubra cómo los sistemas de IA están detectando defectos invisibles al ojo humano y reduciendo pérdidas hasta en un 40%.',
        date: '04 de dic. de 2024',
      },
      {
        title: 'Edge Computing en la Industria: ¿Por qué procesar datos en el borde?',
        excerpt: 'Entienda las ventajas de procesar datos localmente y cómo esto impacta la latencia, seguridad y costos operativos.',
        date: '27 de nov. de 2024',
      },
      {
        title: 'Sistemas Multiagentes: El futuro de la automatización inteligente',
        excerpt: 'Cómo agentes de IA colaborativos están revolucionando procesos industriales y tomando decisiones en tiempo real.',
        date: '19 de nov. de 2024',
      },
    ],
  },

  // ============================================================
  // FORMULARIO DE CONTACTO (Modal HubSpot)
  // ============================================================
  contactForm: {
    title: 'Solicitar',
    titleHighlight: 'Presupuesto',
    name: 'Nombre',
    namePlaceholder: 'Su nombre completo',
    email: 'Correo electrónico',
    emailPlaceholder: 'su@email.com',
    phone: 'Teléfono',
    phonePlaceholder: '+54 (11) 1234-5678',
    company: 'Empresa',
    companyPlaceholder: 'Nombre de la empresa (opcional)',
    message: 'Describa su proyecto',
    messagePlaceholder: 'Cuéntenos un poco sobre el proyecto que necesita desarrollar...',
    submit: 'Enviar Solicitud',
    sending: 'Enviando...',
    successTitle: '¡Mensaje Enviado!',
    successText: 'Recibimos su solicitud y nos pondremos en contacto dentro de 24 horas hábiles.',
    errorRequired: 'Por favor, complete todos los campos obligatorios.',
    errorGeneral: 'Ocurrió un error al enviar. Intente nuevamente o contáctenos por WhatsApp.',
    privacy: 'Al enviar, acepta nuestra política de privacidad. Sus datos están seguros y no serán compartidos.',
  },

  // ============================================================
  // CONTACTO
  // ============================================================
  contact: {
    title: 'Contáctenos',
    subtitle: 'Estamos listos para ayudar a su empresa a evolucionar',
    
    form: {
      name: 'Nombre completo',
      namePlaceholder: 'Su nombre',
      email: 'Correo electrónico',
      emailPlaceholder: 'su@correo.com',
      phone: 'Teléfono',
      phonePlaceholder: '+54 (11) 1234-5678',
      company: 'Empresa',
      companyPlaceholder: 'Nombre de su empresa',
      subject: 'Asunto',
      subjectPlaceholder: '¿Cómo podemos ayudar?',
      message: 'Mensaje',
      messagePlaceholder: 'Describa su necesidad...',
      submit: 'Enviar Mensaje',
      sending: 'Enviando...',
      successMessage: '¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.',
      errorMessage: 'Error al enviar el mensaje. Intente nuevamente.',
    },
    
    info: {
      address: 'Dirección',
      addressValue: 'São Paulo, SP - Brasil',
      email: 'Correo electrónico',
      emailValue: 'contacto@vegarobotics.com.br',
      phone: 'Teléfono',
      phoneValue: '+55 (11) 99999-9999',
      hours: 'Horario',
      hoursValue: 'Lun - Vie: 9h a 18h',
    },
  },

  // ============================================================
  // FOOTER
  // ============================================================
  footer: {
    description: 'Inteligencia artificial para la industria brasileña. Visión por computadora, sistemas multiagentes y edge computing.',
    solutions: 'Soluciones',
    contact: 'Contacto',
    copyright: '© {year} Vega Robotics. Todos los derechos reservados.',
    privacy: 'Privacidad',
    terms: 'Términos de Uso',
    
    links: {
      title: 'Enlaces Rápidos',
      solutions: 'Soluciones',
      contact: 'Contacto',
      privacy: 'Privacidad',
      terms: 'Términos de Uso',
    },
    
    social: {
      title: 'Redes Sociales',
      followUs: 'Síganos',
    },
  },

  // ============================================================
  // PÁGINAS DE ERROR
  // ============================================================
  errors: {
    notFound: {
      title: 'Página No Encontrada',
      description: 'La página que está buscando no existe o fue movida.',
      backHome: 'Volver al Inicio',
    },
    serverError: {
      title: 'Error del Servidor',
      description: 'Ocurrió un error inesperado. Intente nuevamente más tarde.',
      retry: 'Intentar Nuevamente',
    },
  },

  // ============================================================
  // VALIDACIONES DE FORMULARIO
  // ============================================================
  validation: {
    required: 'Este campo es obligatorio',
    email: 'Ingrese un correo válido',
    phone: 'Ingrese un teléfono válido',
    minLength: 'Mínimo de {min} caracteres',
    maxLength: 'Máximo de {max} caracteres',
  },

  // ============================================================
  // ACCESIBILIDAD
  // ============================================================
  accessibility: {
    skipToContent: 'Saltar al contenido',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    toggleLanguage: 'Cambiar idioma',
    darkMode: 'Modo oscuro',
    lightMode: 'Modo claro',
    backToTop: 'Volver arriba',
    play: 'Play',
    pause: 'Pausar',
    clientsAriaLabel: 'Empresas que confían en Vega',
    whatsappAriaLabel: 'Hablar por WhatsApp',
  },

  // ============================================================
  // CARRERAS
  // ============================================================
  careers: {
    pageTitle: 'Trabaja con Nosotros',
    pageSubtitle: 'Únete a un equipo apasionado por la tecnología y la innovación. Construye el futuro de la industria brasileña.',
    openPositions: 'Vacantes Abiertas',
    departments: 'Departamentos',
    searchPlaceholder: 'Buscar vacantes...',
    allDepartments: 'Todos los Departamentos',
    allModalities: 'Todas las Modalidades',
    viewJob: 'Ver Vacante',
    applyNow: 'Aplicar Ahora',
    backToJobs: 'Volver a Vacantes',
    aboutRole: 'Sobre el Puesto',
    requirements: 'Requisitos',
    benefits: 'Beneficios',
    share: 'Compartir',
    noJobsTitle: 'No se encontraron vacantes',
    noJobsText: 'Actualmente no tenemos vacantes abiertas. Síguenos en las redes sociales para estar al tanto.',
    noJobsFiltered: 'Ninguna vacante corresponde a los filtros seleccionados.',
    notFoundTitle: 'Vacante no encontrada',
    notFoundText: 'La vacante que buscas no existe o ha sido cerrada.',

    types: {
      fullTime: 'Tiempo Completo',
      partTime: 'Medio Tiempo',
      contract: 'Contrato',
      internship: 'Pasantía',
      freelance: 'Freelance',
    },

    modalities: {
      onSite: 'Presencial',
      remote: 'Remoto',
      hybrid: 'Híbrido',
    },

    experience: {
      intern: 'Pasante',
      junior: 'Junior',
      mid: 'Semi-Senior',
      senior: 'Senior',
      lead: 'Líder/Gerente',
    },

    form: {
      name: 'Nombre Completo',
      namePlaceholder: 'Tu nombre',
      email: 'Correo',
      emailPlaceholder: 'tu@email.com',
      phone: 'Teléfono',
      phonePlaceholder: '+55 (11) 99999-9999',
      linkedin: 'LinkedIn',
      portfolio: 'Portfolio / GitHub',
      coverLetter: 'Carta de Presentación',
      coverLetterPlaceholder: 'Cuéntanos sobre ti y por qué eres el candidato ideal para este puesto...',
      submit: 'Enviar Aplicación',
      sending: 'Enviando...',
      successTitle: '¡Aplicación Enviada!',
      successMessage: 'Recibimos tu aplicación y nos comunicaremos pronto.',
      errorMessage: 'Ocurrió un error. Intenta nuevamente.',
    },
  },

  // ============================================================
  // WHATSAPP
  // ============================================================
  whatsapp: {
    defaultMessage: '¡Hola! Me gustaría saber más sobre las soluciones de Vega Robotics.',
  },
};
